import Crud from '../components/Departments/Crud'
import Add from '../components/Departments/Add'

let routes = {
    path: '/departments',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/departments',
            name: 'Departamentos',
            component: Crud
        },
        {
            path: '/department/:id?',
            name: 'Departamento',
            component: Add
        }
    ]
};


export default routes



// WEBPACK FOOTER //
// ./src/router/departments.js